import { render, staticRenderFns } from "./EpButton.vue?vue&type=template&id=48fc6543&"
import script from "./EpButton.vue?vue&type=script&lang=js&"
export * from "./EpButton.vue?vue&type=script&lang=js&"
import style0 from "./EpButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports